import { Database, Model } from '@nozbe/watermelondb';

import { ValidationOperation } from '../../../validation/validator';
import {
    EventContactEntityTableName,
    ModelByEventContactEntityTable,
} from '../../../../types/EventContact';

const toPreparedDataItems = <K extends EventContactEntityTableName>(
    records: ModelByEventContactEntityTable[K][],
    table: K,
    operation: ValidationOperation,
) => {
    return records.map((record) => ({
        record,
        table,
        operation,
    }));
};

const addRelatedDataBatch = async (data: Model[], database: Database) => {
    await database.batch(...data);
};

export { toPreparedDataItems, addRelatedDataBatch };
